<main class="p-4 p-xxl-5">
  <section class="card border rounded-3 overflow-hidden">
    <div class="card-header bg-white d-flex align-items-center justify-content-between flex-wrap gap-3 py-3 px-4">
      <div class="d-inline-flex align-items-center flex-wrap border rounded-2 bg-light p-1" role="group" aria-label="Approval filters">
        <button
          v-for="filter in filters"
          :key="filter.label"
          type="button"
          @click="set_active_filter(filter.tone)"
          :class="[
            'btn btn-sm d-inline-flex align-items-center gap-2 px-3 py-1',
            active_filter === filter.tone ? 'bg-white border shadow-sm fw-semibold' : 'border-0 bg-transparent'
          ]"
        >
          <span>{{ filter.label }}</span>
          <span v-if="filter.count">{{ filter.count }}</span>
        </button>
      </div>

      <div class="d-flex align-items-center justify-content-end flex-wrap gap-2">
        <label class="onboarding-queue-search d-inline-flex align-items-center">
          <i class="bi bi-search" aria-hidden="true"></i>
          <input v-model="table_search" type="search" placeholder="Search table" @input="reset_table_page">
        </label>
        <button type="button" class="btn btn-sm bg-white border rounded-2 d-inline-flex align-items-center gap-2 fw-semibold px-3 py-1">
          <i class="bi bi-funnel"></i>
          <span>Filters</span>
        </button>
        <button type="button" class="btn btn-sm bg-white border rounded-2 d-inline-flex align-items-center gap-2 fw-semibold px-3 py-1">
          <i class="bi bi-download"></i>
          <span>Export</span>
        </button>
      </div>
    </div>

    <div class="table-responsive">
      <table class="table align-middle mb-0">
        <thead class="table-light">
          <tr>
            <th class="text-uppercase text-muted small fw-semibold py-3 ps-4">Onboarded Entity</th>
            <th class="text-uppercase text-muted small fw-semibold py-3">Approver</th>
            <th class="text-uppercase text-muted small fw-semibold py-3">Reason</th>
            <th class="text-uppercase text-muted small fw-semibold py-3">DoA</th>
            <th class="text-uppercase text-muted small fw-semibold py-3">Waited</th>
            <th class="text-uppercase text-muted small fw-semibold py-3 pe-4">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="is_loading_approvals">
            <td colspan="6" class="text-center text-muted py-5">Loading approvals...</td>
          </tr>
          <tr v-else-if="approvals_error">
            <td colspan="6" class="py-4">
              <div class="alert alert-warning mb-0">{{ approvals_error }}</div>
            </td>
          </tr>
          <tr v-else-if="filtered_approvals.length === 0">
            <td colspan="6" class="text-center text-muted py-5">No approval items found.</td>
          </tr>
          <tr
            v-else
            v-for="item in paginated_approvals"
            :key="`${item.case_name}-${item.doa}`"
            class="cursor-pointer"
            tabindex="0"
            @click="open_approval_detail(item)"
            @keyup.enter="open_approval_detail(item)"
          >
            <td class="ps-4 fw-bold text-black py-3">{{ item.case_name }}</td>
            <td class="py-3">{{ item.approver }}</td>
            <td class="py-3">{{ item.reason }}</td>
            <td class="py-3">{{ item.doa }}</td>
            <td class="py-3">{{ item.waited }}</td>
            <td class="pe-4 py-3 onboarding-text-navy">
              <span :class="['badge rounded-pill fw-normal', status_badge_class(item.status_tone)]">
                {{ item.status }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <TablePagination
      :page="table_page"
      :page-size="table_page_size"
      :page-size-options="table_page_size_options"
      :total-rows="table_total_rows"
      :page-start="table_page_start"
      :page-end="table_page_end"
      :total-pages="table_total_pages"
      @update:page="set_table_page"
      @update:page-size="set_table_page_size"
    />
  </section>

  <div
    v-if="selected_approval"
    class="onboarding-case-detail-backdrop"
    @click="close_approval_detail"
  ></div>

  <aside
    v-if="selected_approval"
    :class="['onboarding-case-detail-drawer bg-white shadow-lg', { 'is-fullscreen': is_detail_fullscreen }]"
  >
    <header class="border-bottom p-4">
      <div class="d-flex align-items-start justify-content-between gap-3">
        <div class="min-w-0">
          <div class="text-uppercase text-muted fw-semibold small mb-3">
            {{ (selected_case && selected_case.journey) || 'Onboarding' }} onboarding &middot; {{ (selected_approval && selected_approval.reason) || 'Approval review' }}
          </div>
          <h2 class="h5 fw-bold text-black mb-2">{{ (selected_case && selected_case.name) || (selected_approval && selected_approval.case_name) }}</h2>
          <p class="mb-0 text-muted">{{ (selected_approval && selected_approval.approver) || 'Unassigned' }} &middot; {{ (selected_approval && selected_approval.waited) || '-' }} &middot; {{ (selected_approval && selected_approval.doa) || 'Approval' }}</p>
        </div>

        <div class="d-flex align-items-center gap-3 flex-shrink-0">
          <span :class="['badge rounded-pill fw-normal', activation_badge_class()]">
            <span class="me-1">&bull;</span>{{ (selected_case && selected_case.activation) || (selected_approval && selected_approval.status) }}
          </span>
          <button
            type="button"
            class="btn btn-link text-muted p-0"
            :aria-label="is_detail_fullscreen ? 'Exit fullscreen' : 'View fullscreen'"
            :title="is_detail_fullscreen ? 'Exit fullscreen' : 'View fullscreen'"
            @click="toggle_detail_fullscreen"
          >
            <i :class="['bi', is_detail_fullscreen ? 'bi-fullscreen-exit' : 'bi-fullscreen', 'fs-5']"></i>
          </button>
          <button type="button" class="btn btn-link text-muted p-0" aria-label="Close approval detail" @click="close_approval_detail">
            <i class="bi bi-x-lg fs-5"></i>
          </button>
        </div>
      </div>
    </header>

    <div class="onboarding-case-detail-body p-4">
      <nav class="bg-light rounded-3 p-1 d-flex align-items-center gap-2 mb-4" aria-label="Approval detail sections">
        <button
          v-for="tab in detail_tabs"
          :key="tab.id"
          type="button"
          :class="[
            'btn btn-sm flex-fill d-inline-flex align-items-center justify-content-center gap-2',
            active_detail_tab === tab.id ? 'bg-white border shadow-sm fw-semibold' : 'border-0 bg-transparent'
          ]"
          @click="set_detail_tab(tab.id)"
        >
          <i :class="['bi', tab.icon]"></i>
          <span>{{ tab.label }}</span>
          <span v-if="tab.count" class="badge rounded-pill text-bg-danger">{{ tab.count }}</span>
        </button>
      </nav>
      <section class="border rounded-3 bg-light-subtle px-4 py-3 mb-4" aria-label="Current approval action">
        <div class="text-uppercase text-muted fw-semibold small mb-2">Required Action</div>
        <p class="text-muted mb-0">{{ current_detail_action_copy() }}</p>
      </section>
      <section v-if="active_detail_tab === 'summary'">
        <dl class="row g-0 mb-4">
          <template v-for="row in summary_rows" :key="row.label">
            <dt class="col-4 text-muted fw-normal mb-3">{{ row.label }}</dt>
            <dd class="col-8 fw-semibold mb-3">{{ row.value }}</dd>
          </template>
          <dt class="col-4 text-muted fw-normal mb-3">Approver</dt>
          <dd class="col-8 fw-semibold mb-3">{{ (selected_approval && selected_approval.approver) || 'Unassigned' }}</dd>
          <dt class="col-4 text-muted fw-normal mb-3">DoA</dt>
          <dd class="col-8 fw-semibold mb-3">{{ (selected_approval && selected_approval.doa) || 'Approval' }}</dd>
          <dt class="col-4 text-muted fw-normal">Approval status</dt>
          <dd class="col-8 fw-semibold">{{ (selected_approval && selected_approval.status) || '-' }}</dd>
        </dl>

        <section class="mb-4">
          <div class="text-uppercase text-muted fw-semibold small mb-3">Overall readiness</div>
          <div class="d-flex align-items-center gap-3">
            <div class="progress flex-grow-1 onboarding-progress-track">
              <div
                class="progress-bar onboarding-progress-bar"
                :style="{ '--onboarding-progress-size': `${(selected_case && selected_case.progress) || 0}%`, '--onboarding-progress-color': progress_bar_color() }"
              ></div>
            </div>
            <span class="small fw-bold">{{ (selected_case && selected_case.progress) || 0 }}%</span>
          </div>
        </section>

        <section>
          <div class="text-uppercase text-muted fw-semibold small mb-3">Stage timeline</div>
          <div class="onboarding-case-timeline">
            <article
              v-for="item in stage_timeline"
              :key="item.title"
              :class="['onboarding-case-timeline-item', `is-${item.status}`]"
            >
              <span class="onboarding-case-timeline-icon">
                <i :class="['bi', item.icon]"></i>
              </span>
              <div>
                <div class="fw-semibold text-black">{{ item.title }}</div>
                <div class="text-muted small mt-1">{{ item.detail }}</div>
              </div>
            </article>
          </div>
        </section>
      </section>

      <section v-else-if="active_form_section">
        <div class="text-uppercase text-muted fw-semibold small mb-3">{{ active_form_section.label }}</div>
        <section
          v-for="sub_section in active_form_section.sub_sections"
          :key="sub_section.id"
          class="mb-4"
        >
          <div
            v-if="sub_section.label && sub_section.label !== active_form_section.label"
            class="text-uppercase text-muted fw-semibold small mb-3"
          >
            {{ sub_section.label }}
          </div>
          <div class="onboarding-answer-grid">
            <article
              v-for="question in sub_section.questions"
              :key="question.id"
              class="onboarding-answer-card"
            >
              <p class="onboarding-answer-card__label">
                {{ question.label }}
                <span v-if="question.is_mandatory" class="text-danger">*</span>
              </p>
              <div class="onboarding-answer-card__value">{{ question.answer }}</div>
            </article>
          </div>
        </section>
      </section>

      <section v-else-if="active_detail_tab === 'agreements'">
        <div class="d-flex align-items-center justify-content-between mb-3">
          <div class="text-uppercase text-muted fw-semibold small">Agreements & e-signing</div>
          <div class="text-uppercase text-muted fw-semibold small">{{ agreement_rows.length }} documents</div>
        </div>

        <div class="d-grid gap-3">
          <article
            v-for="item in agreement_rows"
            :key="item.id"
            class="border rounded-3 p-3"
          >
            <div class="d-flex align-items-start gap-3">
              <span :class="['rounded-3 d-inline-flex align-items-center justify-content-center flex-shrink-0 onboarding-icon-square-21', item.tone_class]">
                <i :class="['bi', item.icon]"></i>
              </span>
              <div class="min-w-0 flex-grow-1">
                <div class="fw-bold text-black mb-1">{{ item.title }}</div>
                <div class="text-muted small">{{ item.detail || 'Approval evidence document' }}</div>
              </div>
              <div class="d-flex flex-column align-items-end gap-3 flex-shrink-0">
                <span :class="['badge rounded-pill', item.tone_class]">
                  <span class="me-1">&bull;</span>{{ item.status }}
                </span>
                <button
                  v-if="item.url"
                  type="button"
                  class="btn btn-link btn-sm text-muted text-decoration-none d-inline-flex align-items-center gap-2 p-0"
                >
                  <i class="bi bi-download"></i>
                  <span>PDF</span>
                </button>
              </div>
            </div>
          </article>

          <p v-if="agreement_rows.length === 0" class="text-muted mb-0">
            No agreement or approval documents returned for this onboarding.
          </p>

        </div>
      </section>
    </div>

    <footer class="onboarding-case-detail-footer border-top bg-white p-3 d-flex align-items-center justify-content-between gap-3">
      <button type="button" class="btn btn-link text-muted d-inline-flex align-items-center gap-2 text-decoration-none">
        <i class="bi bi-stars"></i>
        <span>Ask AI</span>
      </button>
      <div class="d-flex align-items-center gap-2">
          <button
          type="button"
          class="btn btn-outline-danger d-inline-flex align-items-center gap-2"
          :disabled="workflow_action_in_progress === 'reject' || workflow_actions_loading"
          @click="run_selected_workflow_action('reject')"
        >
          <i class="bi bi-x-circle"></i>
          <span>{{ workflow_action_in_progress === 'reject' ? 'Rejecting...' : 'Reject' }}</span>
        </button>
        <button
          type="button"
          class="btn btn-outline-warning d-inline-flex align-items-center gap-2"
          :disabled="workflow_action_in_progress === 'request_info' || workflow_actions_loading"
          @click="run_selected_workflow_action('request_info')"
        >
          <i class="bi bi-send"></i>
          <span>{{ workflow_action_in_progress === 'request_info' ? 'Sending...' : 'Request info' }}</span>
        </button>
        <button
          v-if="can_advance_stage"
          type="button"
          class="btn btn-primary d-inline-flex align-items-center gap-2"
          :disabled="workflow_action_in_progress === 'advance' || workflow_actions_loading"
          @click="run_selected_workflow_action('advance')"
        >
          <i class="bi bi-arrow-right"></i>
          <span>{{ workflow_action_in_progress === 'advance' ? 'Advancing...' : 'Advance stage' }}</span>
        </button>
      </div>
    </footer>
    <div v-if="workflow_actions_loading || workflow_actions_error || workflow_action_feedback" class="px-3 pb-3">
      <div v-if="workflow_actions_loading" class="small text-muted">Loading workflow actions...</div>
      <div v-else-if="workflow_actions_error" class="alert alert-warning mb-0 py-2 px-3 small">{{ workflow_actions_error }}</div>
      <div
        v-else-if="workflow_action_feedback"
        :class="['alert mb-0 py-2 px-3 small', workflow_action_feedback_tone === 'success' ? 'alert-success' : workflow_action_feedback_tone === 'danger' ? 'alert-danger' : 'alert-warning']"
      >
        {{ workflow_action_feedback }}
      </div>
    </div>
  </aside>

  <AgreementSignModal
    :visible="sign_modal.visible"
    :agreement-title="sign_modal.agreement_title"
    :signatory-name="sign_modal.signatory_name"
    :document-id="sign_modal.document_id"
    @close="close_sign_modal"
    @signed="complete_signature"
  />
</main>
